import styled from 'styled-components';
import { InputAdornment } from '@mui/material';
import { ReactComponent as SearchIcon } from '../../assets/search.svg';
import TextField, { TextFieldProps } from '../TextField';

const TextFieldStyled = styled(TextField)`
  .MuiInputBase-root.Mui-focused {
    svg > path {
      fill: ${({ theme }) => theme.palette.icon.primary};
    }
  }
`;

const SearchField = (props: TextFieldProps) => (
  <TextFieldStyled
    placeholder="Search"
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      ),
    }}
    {...props}
  />
);

export default SearchField;
